// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../eckpunkt-app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../eckpunkt-app/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.single-range-slider[data-v-63be847c] {
  width: 100%;
  position: relative;
  padding: 20px 0;
}
.slider-container[data-v-63be847c] {
  position: relative;
  height: 40px;
  margin: 0 15px;
}

/* Background Ranges */
.background-ranges[data-v-63be847c] {
  position: absolute;
  top: 8px; /* Zentriert die 20px hohen ranges um den 4px track */
  left: 0;
  right: 0;
  height: 20px;
  z-index: 1;
}
.background-range[data-v-63be847c] {
  position: absolute;
  height: 20px;
  border-radius: 6px;
  opacity: 0.7;
  background-color: transparent; /* Will be overridden by inline styles */
}
.background-range.background-solid[data-v-63be847c] {
  border: 2px solid;
}
.background-range.background-dashed[data-v-63be847c] {
  border: 3px dashed;
  box-shadow: 0 0 0 1px;
}
.background-range.background-dotted[data-v-63be847c] {
  border: 3px dotted;
  box-shadow: 0 0 0 1px;
}

/* Track */
.slider-track[data-v-63be847c] {
  position: absolute;
  top: 18px;
  left: 0;
  right: 0;
  height: 4px;
  background-color: #e5e7eb;
  border-radius: 2px;
  z-index: 2;
}

/* Input */
.slider-input[data-v-63be847c] {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 40px;
  opacity: 0;
  cursor: pointer;
  z-index: 4;
}
.slider-input[data-v-63be847c]:disabled {
  cursor: not-allowed;
}

/* Handle */
.slider-handle[data-v-63be847c] {
  position: absolute;
  top: 10px;
  transform: translateX(-50%);
  z-index: 3;
}
.slider-handle[data-v-63be847c]::before {
  content: '';
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  transition: all 0.2s ease;
}
.handle-value[data-v-63be847c] {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #374151;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.handle-value[data-v-63be847c]::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 4px solid transparent;
  border-top-color: #374151;
}

/* Color Variants */
.slider-handle-red[data-v-63be847c]::before { background-color: #ef4444;
}
.slider-handle-blue[data-v-63be847c]::before { background-color: #3b82f6;
}
.slider-handle-green[data-v-63be847c]::before { background-color: #10b981;
}
.slider-handle-yellow[data-v-63be847c]::before { background-color: #f59e0b;
}

/* Min/Max Labels */
.min-max-labels[data-v-63be847c] {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding: 0 15px;
  font-size: 12px;
  color: #6b7280;
}

/* Hover Effects */
.slider-input:hover ~ .slider-handle[data-v-63be847c]::before {
  transform: translateX(-50%) scale(1.1);
}
.slider-input:active ~ .slider-handle[data-v-63be847c]::before {
  transform: translateX(-50%) scale(0.95);
}

/* Disabled State */
.slider-input:disabled ~ .slider-handle[data-v-63be847c] {
  opacity: 0.5;
}
.slider-input:disabled ~ .slider-handle[data-v-63be847c]::before {
  background-color: #9ca3af !important;
}

/* Mobile Optimizations */
@media (max-width: 640px) {
.slider-handle[data-v-63be847c] {
    top: 8px;
}
.slider-handle[data-v-63be847c]::before {
    width: 24px;
    height: 24px;
    top: 6px;
}
.handle-value[data-v-63be847c] {
    font-size: 11px;
    padding: 3px 6px;
    top: -12px;
}
}
`, "",{"version":3,"sources":["webpack://./../@shared/src/components/checkout/SingleRangeSlider.vue"],"names":[],"mappings":";AAuHA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,QAAQ,EAAE,qDAAqD;EAC/D,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,UAAU;AACZ;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,6BAA6B,EAAE,wCAAwC;AACzE;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,UAAU;AACZ;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,UAAU;AACZ;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;AAC3B;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;AAC1C;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB,8CAA6B,yBAAyB;AAAE;AACxD,+CAA8B,yBAAyB;AAAE;AACzD,gDAA+B,yBAAyB;AAAE;AAC1D,iDAAgC,yBAAyB;AAAE;;AAE3D,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,sCAAsC;AACxC;AAEA;EACE,uCAAuC;AACzC;;AAEA,mBAAmB;AACnB;EACE,YAAY;AACd;AAEA;EACE,oCAAoC;AACtC;;AAEA,yBAAyB;AACzB;AACE;IACE,QAAQ;AACV;AAEA;IACE,WAAW;IACX,YAAY;IACZ,QAAQ;AACV;AAEA;IACE,eAAe;IACf,gBAAgB;IAChB,UAAU;AACZ;AACF","sourcesContent":["<template>\r\n  <div class=\"single-range-slider\">\r\n    <div class=\"slider-container\">\r\n      <!-- Background Ranges (Admin Panel Style) -->\r\n      <div v-if=\"backgroundRanges?.length\" class=\"background-ranges\">\r\n        <div \r\n          v-for=\"(range, index) in backgroundRanges\" \r\n          :key=\"index\"\r\n          class=\"background-range\"\r\n          :class=\"getBackgroundClass(range.color)\"\r\n          :style=\"{ \r\n            left: `${((range.start - min) / (max - min)) * 100}%`, \r\n            width: `${((range.end - range.start) / (max - min)) * 100}%`,\r\n            zIndex: 10 - index\r\n          }\"\r\n          :title=\"range.label\"\r\n        ></div>\r\n      </div>\r\n      \r\n      <!-- Track -->\r\n      <div class=\"slider-track\"></div>\r\n      \r\n      <!-- Value Handle -->\r\n      <input\r\n        type=\"range\"\r\n        :min=\"min\"\r\n        :max=\"max\"\r\n        :step=\"step\"\r\n        :value=\"value\"\r\n        :disabled=\"disabled\"\r\n        @input=\"handleInput\"\r\n        class=\"slider-input\"\r\n        :class=\"`slider-input-${color}`\"\r\n      />\r\n      \r\n      <!-- Current Value Display -->\r\n      <div \r\n        class=\"slider-handle\"\r\n        :class=\"`slider-handle-${color}`\"\r\n        :style=\"{ left: `${valuePercent}%` }\"\r\n      >\r\n        <div class=\"handle-value\">{{ formattedValue }}</div>\r\n      </div>\r\n    </div>\r\n    \r\n    <!-- Min/Max Labels -->\r\n    <div v-if=\"showMinMax\" class=\"min-max-labels\">\r\n      <span class=\"min-label\">{{ formatValue(min) }}</span>\r\n      <span class=\"max-label\">{{ formatValue(max) }}</span>\r\n    </div>\r\n  </div>\r\n</template>\r\n\r\n<script setup lang=\"ts\">\r\nimport { computed } from 'vue';\r\n\r\ninterface BackgroundRange {\r\n  start: number;\r\n  end: number;\r\n  color?: string;\r\n  label?: string;\r\n}\r\n\r\ninterface Props {\r\n  value: number;\r\n  min: number;\r\n  max: number;\r\n  step?: number;\r\n  disabled?: boolean;\r\n  color?: 'red' | 'blue' | 'green' | 'yellow';\r\n  formatValue?: (value: number) => string;\r\n  backgroundRanges?: BackgroundRange[];\r\n  backgroundStyle?: 'solid' | 'dashed' | 'dotted';\r\n  showMinMax?: boolean;\r\n}\r\n\r\ninterface Emits {\r\n  (e: 'update:value', value: number): void;\r\n}\r\n\r\nconst props = withDefaults(defineProps<Props>(), {\r\n  step: 1,\r\n  disabled: false,\r\n  color: 'blue',\r\n  formatValue: (value: number) => value.toString(),\r\n  backgroundRanges: () => [],\r\n  backgroundStyle: 'solid',\r\n  showMinMax: false\r\n});\r\n\r\nconst emit = defineEmits<Emits>();\r\n\r\n// ✅ COMPUTED VALUES\r\nconst valuePercent = computed(() => {\r\n  return ((props.value - props.min) / (props.max - props.min)) * 100;\r\n});\r\n\r\nconst formattedValue = computed(() => {\r\n  return props.formatValue(props.value);\r\n});\r\n\r\n// ✅ METHODS\r\nconst getBackgroundClass = (color?: string) => {\r\n  // Admin Panel Style: Grün für verfügbare Zeiten, Grau für geschlossen, Orange für Puffer\r\n  if (color === '#22c55e' || color === 'green') return 'background-green';\r\n  if (color === '#9ca3af' || color === 'gray') return 'background-gray';\r\n  if (color === '#f59e0b' || color === 'orange') return 'background-orange';\r\n  return 'background-green'; // Default zu grün (verfügbar)\r\n};\r\n\r\n// ✅ EVENT HANDLERS\r\nconst handleInput = (event: Event) => {\r\n  const target = event.target as HTMLInputElement;\r\n  const value = Number(target.value);\r\n  emit('update:value', value);\r\n};\r\n</script>\r\n\r\n<style scoped>\r\n.single-range-slider {\r\n  width: 100%;\r\n  position: relative;\r\n  padding: 20px 0;\r\n}\r\n\r\n.slider-container {\r\n  position: relative;\r\n  height: 40px;\r\n  margin: 0 15px;\r\n}\r\n\r\n/* Background Ranges */\r\n.background-ranges {\r\n  position: absolute;\r\n  top: 8px; /* Zentriert die 20px hohen ranges um den 4px track */\r\n  left: 0;\r\n  right: 0;\r\n  height: 20px;\r\n  z-index: 1;\r\n}\r\n\r\n.background-range {\r\n  position: absolute;\r\n  height: 20px;\r\n  border-radius: 6px;\r\n  opacity: 0.7;\r\n  background-color: transparent; /* Will be overridden by inline styles */\r\n}\r\n\r\n.background-range.background-solid {\r\n  border: 2px solid;\r\n}\r\n\r\n.background-range.background-dashed {\r\n  border: 3px dashed;\r\n  box-shadow: 0 0 0 1px;\r\n}\r\n\r\n.background-range.background-dotted {\r\n  border: 3px dotted;\r\n  box-shadow: 0 0 0 1px;\r\n}\r\n\r\n/* Track */\r\n.slider-track {\r\n  position: absolute;\r\n  top: 18px;\r\n  left: 0;\r\n  right: 0;\r\n  height: 4px;\r\n  background-color: #e5e7eb;\r\n  border-radius: 2px;\r\n  z-index: 2;\r\n}\r\n\r\n/* Input */\r\n.slider-input {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  height: 40px;\r\n  opacity: 0;\r\n  cursor: pointer;\r\n  z-index: 4;\r\n}\r\n\r\n.slider-input:disabled {\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Handle */\r\n.slider-handle {\r\n  position: absolute;\r\n  top: 10px;\r\n  transform: translateX(-50%);\r\n  z-index: 3;\r\n}\r\n\r\n.slider-handle::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 8px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 50%;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.handle-value {\r\n  position: absolute;\r\n  top: -10px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background-color: #374151;\r\n  color: white;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.handle-value::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  border: 4px solid transparent;\r\n  border-top-color: #374151;\r\n}\r\n\r\n/* Color Variants */\r\n.slider-handle-red::before { background-color: #ef4444; }\r\n.slider-handle-blue::before { background-color: #3b82f6; }\r\n.slider-handle-green::before { background-color: #10b981; }\r\n.slider-handle-yellow::before { background-color: #f59e0b; }\r\n\r\n/* Min/Max Labels */\r\n.min-max-labels {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-top: 10px;\r\n  padding: 0 15px;\r\n  font-size: 12px;\r\n  color: #6b7280;\r\n}\r\n\r\n/* Hover Effects */\r\n.slider-input:hover ~ .slider-handle::before {\r\n  transform: translateX(-50%) scale(1.1);\r\n}\r\n\r\n.slider-input:active ~ .slider-handle::before {\r\n  transform: translateX(-50%) scale(0.95);\r\n}\r\n\r\n/* Disabled State */\r\n.slider-input:disabled ~ .slider-handle {\r\n  opacity: 0.5;\r\n}\r\n\r\n.slider-input:disabled ~ .slider-handle::before {\r\n  background-color: #9ca3af !important;\r\n}\r\n\r\n/* Mobile Optimizations */\r\n@media (max-width: 640px) {\r\n  .slider-handle {\r\n    top: 8px;\r\n  }\r\n  \r\n  .slider-handle::before {\r\n    width: 24px;\r\n    height: 24px;\r\n    top: 6px;\r\n  }\r\n  \r\n  .handle-value {\r\n    font-size: 11px;\r\n    padding: 3px 6px;\r\n    top: -12px;\r\n  }\r\n}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
